// FP-4 (M-1): la columna «Margen» de la lista de Cotizaciones. Sin `view_costs` el servidor quita el margen
// del espejo del Pricer (`costosOcultos`): se muestra «—», nunca un «0 %» (un cero se lee como un dato) y
// nunca se llama a `toFixed` sobre un campo que no llegó.

import { formatPercentage } from '@/lib/utils/format';

interface Props {
  actualMargin?: number | null;
  targetMargin?: number | null;
  floorMargin?: number | null;
  /** El servidor lo ocultó a propósito (no tiene la clave «Ver costos y márgenes»). */
  costosOcultos?: boolean;
  /** «Margen Op.» (Pricer) o «Margen Bruto» (estándar). */
  etiqueta: string;
}

export function MargenDeLaCotizacion({
  actualMargin,
  targetMargin,
  floorMargin,
  costosOcultos,
  etiqueta,
}: Props) {
  const sinDato = costosOcultos || typeof actualMargin !== 'number' || Number.isNaN(actualMargin);
  if (sinDato) {
    return (
      <>
        <span
          className="font-semibold text-muted-foreground"
          title="Tu cargo no ve costos ni márgenes"
          data-testid="margen-oculto"
        >
          —
        </span>
        <p className="text-[11px] text-muted-foreground whitespace-nowrap">{etiqueta}</p>
      </>
    );
  }
  const color =
    actualMargin >= (targetMargin ?? 0)
      ? 'text-ok'
      : actualMargin >= (floorMargin ?? 0)
        ? 'text-alerta'
        : 'text-destructive';
  return (
    <>
      <span className={`font-semibold ${color}`}>{formatPercentage(actualMargin, 2)}</span>
      <p className="text-[11px] text-muted-foreground whitespace-nowrap">{etiqueta}</p>
    </>
  );
}
